import React, { useEffect, useState } from 'react';
import AdvancedModal from '@portal/components/AdvancedModal/AdvancedModal';
import AlertService from '@portal/services/AlertService';

interface AlertOptions {
  title: string;
  message: string;
  buttons?: Array<{
    text: string;
    onPress?: () => void;
  }>;
  cancelable?: boolean;
  closeButton?: boolean;
}

const AlertModalProvider = () => {
  const [alert, setAlert] = useState<AlertOptions | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const alertService = AlertService.getInstance();
    const unsubscribe = alertService.subscribe((options: AlertOptions) => {
      setAlert(options);
      setVisible(true);
    });

    return unsubscribe;
  }, []);

  const handleClose = () => {
    if (alert?.cancelable !== false) {
      setVisible(false);
      setAlert(null);
    }
  };

  const handleButtonPress = (onPress?: () => void) => {
    if (onPress) {
      onPress();
    }
    setVisible(false);
    setAlert(null);
  };

  if (!alert) {
    return null;
  }

  let actions = alert.buttons?.map((button) => ({
    label: button.text,
    onClick: () => handleButtonPress(button.onPress),
    type: 'ok' as const,
  }));

  if (!actions || actions.length === 0) {
    actions = [
      {
        label: 'OK',
        onClick: handleClose,
        type: 'ok' as const,
      },
    ];
  }

  return (
    <AdvancedModal
      visible={visible}
      title={alert.title}
      onClose={alert.cancelable !== false ? handleClose : undefined}
      actions={actions}
      size="small"
      autoHeight
    >
      <div style={{ textAlign: 'center' }}>{alert.message}</div>
    </AdvancedModal>
  );
};

export default AlertModalProvider;
